import React from "react";
import "../App.scss";
import AclApi from "../api/AclApi";
import LeftMenu from "./LeftMenu";
import { Button, ButtonGroup } from "react-bootstrap";

class QuickFilterButton extends React.Component<any, any> {
  
  constructor(props: any) {
    super(props);
    this.state = {selected:null}
  }

  render() {
    const buttons = this.props.items && this.props.items.map((fi:string) => {
      return <Button variant={(this.state.selected || this.props.selected )== fi ? 'success' : 'secondary'} style={{marginRight:"3px"}} onClick={() => {
        this.props.onSelect(fi)
        this.setState({selected:fi});
      }}>{fi}</Button>;
    })

    return (
      <ButtonGroup size="sm">
        {buttons}
      </ButtonGroup>
    );
  }
}

export default QuickFilterButton;
